import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { withFormik } from 'formik';
import { validation } from '../../forms/util/validation';
import { AuthenticationState } from "react-aad-msal";
import * as yup from 'yup';
import { getLoyaltyStorage, orderError } from '../../../util';

var orderErrorTracker = function orderErrorTracker(message) {
  orderError({
    message: message
  });
};

var authenticatedSchema = yup.object().shape({
  firstName: validation.firstName,
  lastName: validation.lastName,
  email: validation.emailAddress,
  phone: validation.phoneNumber,
  expDate: validation.expDate,
  cvv: validation.cvv,
  shippingStreetAddress: validation.shippingStreetAddress,
  shippingStreetAddress2: validation.shippingStreetAddress2,
  shippingCity: validation.shippingCity,
  shippingState: validation.shippingState,
  shippingZip: validation.shippingZip,
  shippingOther: validation.shippingOther,
  retailStreetAddress: validation.retailStreetAddress,
  retailStreetAddress2: validation.retailStreetAddress2,
  retailCity: validation.retailCity,
  retailState: validation.retailState,
  retailZip: validation.retailZip,
  retailOther: validation.retailOther,
  billingStreetAddress: validation.billingStreetAddress,
  billingCity: validation.billingCity,
  billingZip: validation.billingZip,
  billingState: validation.billingState,
  billingOther: validation.billingOther,
  curbsideColor: validation.curbsideColor,
  curbsideMake: validation.curbsideMake,
  curbsideModel: validation.curbsideModel,
  giftCardNumber: validation.giftCardNumber,
  giftCardPin: validation.giftCardPin,
  isTokenExEnabled: validation.isTokenExEnabled,
  giftCardApplied: validation.giftCardApplied
});
var unAuthenticatedSchema = yup.object().shape({
  firstName: validation.firstName,
  lastName: validation.lastName,
  email: validation.emailAddress,
  phone: validation.phoneNumber,
  expDate: validation.expDate,
  cvv: validation.cvv,
  shippingStreetAddress: validation.shippingStreetAddress,
  shippingStreetAddress2: validation.shippingStreetAddress2,
  shippingCity: validation.shippingCity,
  shippingState: validation.shippingState,
  shippingZip: validation.shippingZip,
  shippingOther: validation.shippingOther,
  retailStreetAddress: validation.retailStreetAddress,
  retailStreetAddress2: validation.retailStreetAddress2,
  retailCity: validation.retailCity,
  retailState: validation.retailState,
  retailZip: validation.retailZip,
  retailOther: validation.retailOther,
  billingStreetAddress: validation.billingStreetAddress,
  billingCity: validation.billingCity,
  billingZip: validation.billingZip,
  billingState: validation.billingState,
  billingOther: validation.billingOther,
  curbsideColor: validation.curbsideColor,
  curbsideMake: validation.curbsideMake,
  curbsideModel: validation.curbsideModel,
  giftCardNumber: validation.giftCardNumber,
  giftCardPin: validation.giftCardPin,
  isTokenExEnabled: validation.isTokenExEnabled,
  giftCardApplied: validation.giftCardApplied
});
export var formikEnhancer = withFormik({
  enableReinitialize: false,
  initialValues: {
    saveDeliveryAddress: false,
    isTokenExEnabled: false
  },
  mapPropsToTouched: function mapPropsToTouched(props) {
    var _props$account, _props$account2, _props$accountInfo, _props$accountInfo$ac, _props$accountInfo2, _props$accountInfo2$a, _defaultAccountInfo$e, _ref, _props$firstName, _loyaltyStorage$accou, _ref2, _props$lastName, _loyaltyStorage$accou2, _props$email, _ref3, _props$phone, _loyaltyStorage$accou3, _props$shippingStreet, _props$shippingStreet2, _props$shippingCity, _props$shippingState, _props$shippingZip, _props$billingStreetA, _props$billingCity, _props$billingState, _props$billingZip;

    // const billingAddress = props?.account?.addresses.filter(x => x.isBillingAddress)[0];
    // const shippingAddress = props?.account?.addresses.filter(x => x.isPrimaryShippingAddress)[0];
    var defaultAddress = (props === null || props === void 0 ? void 0 : (_props$account = props.account) === null || _props$account === void 0 ? void 0 : _props$account.addresses) === undefined ? {} : props === null || props === void 0 ? void 0 : (_props$account2 = props.account) === null || _props$account2 === void 0 ? void 0 : _props$account2.addresses[0];
    var defaultAccountInfo = (props === null || props === void 0 ? void 0 : (_props$accountInfo = props.accountInfo) === null || _props$accountInfo === void 0 ? void 0 : (_props$accountInfo$ac = _props$accountInfo.account) === null || _props$accountInfo$ac === void 0 ? void 0 : _props$accountInfo$ac.idTokenClaims) == null ? {} : props === null || props === void 0 ? void 0 : (_props$accountInfo2 = props.accountInfo) === null || _props$accountInfo2 === void 0 ? void 0 : (_props$accountInfo2$a = _props$accountInfo2.account) === null || _props$accountInfo2$a === void 0 ? void 0 : _props$accountInfo2$a.idTokenClaims;
    var hasEmail = (defaultAccountInfo === null || defaultAccountInfo === void 0 ? void 0 : (_defaultAccountInfo$e = defaultAccountInfo.emails) === null || _defaultAccountInfo$e === void 0 ? void 0 : _defaultAccountInfo$e.length) > 0;
    var loyaltyStorage = getLoyaltyStorage();
    return {
      firstName: (_ref = (_props$firstName = props.firstName) !== null && _props$firstName !== void 0 ? _props$firstName : loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.FirstName) !== null && _ref !== void 0 ? _ref : '',
      lastName: (_ref2 = (_props$lastName = props.lastName) !== null && _props$lastName !== void 0 ? _props$lastName : loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.LastName) !== null && _ref2 !== void 0 ? _ref2 : '',
      email: (_props$email = props.email) !== null && _props$email !== void 0 ? _props$email : hasEmail ? defaultAccountInfo === null || defaultAccountInfo === void 0 ? void 0 : defaultAccountInfo.emails[0] : defaultAccountInfo === null || defaultAccountInfo === void 0 ? void 0 : defaultAccountInfo.email,
      phone: (_ref3 = (_props$phone = props.phone) !== null && _props$phone !== void 0 ? _props$phone : loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou3 = loyaltyStorage.account) === null || _loyaltyStorage$accou3 === void 0 ? void 0 : _loyaltyStorage$accou3.HomePhone) !== null && _ref3 !== void 0 ? _ref3 : '',
      shippingStreetAddress: (_props$shippingStreet = props.shippingStreetAddress) !== null && _props$shippingStreet !== void 0 ? _props$shippingStreet : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.address1,
      shippingStreetAddress2: (_props$shippingStreet2 = props.shippingStreetAddress2) !== null && _props$shippingStreet2 !== void 0 ? _props$shippingStreet2 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.address2,
      shippingCity: (_props$shippingCity = props.shippingCity) !== null && _props$shippingCity !== void 0 ? _props$shippingCity : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.city,
      shippingState: (_props$shippingState = props.shippingState) !== null && _props$shippingState !== void 0 ? _props$shippingState : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.state,
      shippingZip: (_props$shippingZip = props.shippingZip) !== null && _props$shippingZip !== void 0 ? _props$shippingZip : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.zipCode,
      billingStreetAddress: (_props$billingStreetA = props.billingStreetAddress) !== null && _props$billingStreetA !== void 0 ? _props$billingStreetA : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.address1,
      billingCity: (_props$billingCity = props.billingCity) !== null && _props$billingCity !== void 0 ? _props$billingCity : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.city,
      billingState: (_props$billingState = props.billingState) !== null && _props$billingState !== void 0 ? _props$billingState : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.state,
      billingZip: (_props$billingZip = props.billingZip) !== null && _props$billingZip !== void 0 ? _props$billingZip : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.zipCode,
      curbsideMake: props.curbsideMake,
      curbsideModel: props.curbsideModel,
      curbsideColor: props.curbsideColor,
      isTokenExEnabled: props.fullCart.isTokenExEnabled
    };
  },
  mapPropsToValues: function mapPropsToValues(props) {
    var _props$account3, _props$account4, _props$accountInfo3, _props$accountInfo3$a, _props$accountInfo4, _props$accountInfo4$a, _defaultAccountInfo$e2, _ref4, _props$firstName2, _loyaltyStorage$accou4, _ref5, _props$lastName2, _loyaltyStorage$accou5, _props$email2, _ref6, _props$phone2, _loyaltyStorage$accou6, _props$shippingStreet3, _props$shippingStreet4, _props$shippingCity2, _props$shippingState2, _props$shippingZip2, _props$billingStreetA2, _props$billingCity2, _props$billingState2, _props$billingZip2;

    // const billingAddress = props?.account?.addresses.filter(x => x.isBillingAddress)[0];
    // const shippingAddress = props?.account?.addresses.filter(x => x.isPrimaryShippingAddress)[0];
    var defaultAddress = (props === null || props === void 0 ? void 0 : (_props$account3 = props.account) === null || _props$account3 === void 0 ? void 0 : _props$account3.addresses) === undefined ? {} : props === null || props === void 0 ? void 0 : (_props$account4 = props.account) === null || _props$account4 === void 0 ? void 0 : _props$account4.addresses[0];
    var defaultAccountInfo = (props === null || props === void 0 ? void 0 : (_props$accountInfo3 = props.accountInfo) === null || _props$accountInfo3 === void 0 ? void 0 : (_props$accountInfo3$a = _props$accountInfo3.account) === null || _props$accountInfo3$a === void 0 ? void 0 : _props$accountInfo3$a.idTokenClaims) == null ? {} : props === null || props === void 0 ? void 0 : (_props$accountInfo4 = props.accountInfo) === null || _props$accountInfo4 === void 0 ? void 0 : (_props$accountInfo4$a = _props$accountInfo4.account) === null || _props$accountInfo4$a === void 0 ? void 0 : _props$accountInfo4$a.idTokenClaims;
    var hasEmail = (defaultAccountInfo === null || defaultAccountInfo === void 0 ? void 0 : (_defaultAccountInfo$e2 = defaultAccountInfo.emails) === null || _defaultAccountInfo$e2 === void 0 ? void 0 : _defaultAccountInfo$e2.length) > 0;
    var loyaltyStorage = getLoyaltyStorage();
    return {
      firstName: (_ref4 = (_props$firstName2 = props.firstName) !== null && _props$firstName2 !== void 0 ? _props$firstName2 : loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou4 = loyaltyStorage.account) === null || _loyaltyStorage$accou4 === void 0 ? void 0 : _loyaltyStorage$accou4.FirstName) !== null && _ref4 !== void 0 ? _ref4 : '',
      lastName: (_ref5 = (_props$lastName2 = props.lastName) !== null && _props$lastName2 !== void 0 ? _props$lastName2 : loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou5 = loyaltyStorage.account) === null || _loyaltyStorage$accou5 === void 0 ? void 0 : _loyaltyStorage$accou5.LastName) !== null && _ref5 !== void 0 ? _ref5 : '',
      email: (_props$email2 = props.email) !== null && _props$email2 !== void 0 ? _props$email2 : hasEmail ? defaultAccountInfo === null || defaultAccountInfo === void 0 ? void 0 : defaultAccountInfo.emails[0] : defaultAccountInfo === null || defaultAccountInfo === void 0 ? void 0 : defaultAccountInfo.email,
      phone: (_ref6 = (_props$phone2 = props.phone) !== null && _props$phone2 !== void 0 ? _props$phone2 : loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou6 = loyaltyStorage.account) === null || _loyaltyStorage$accou6 === void 0 ? void 0 : _loyaltyStorage$accou6.HomePhone) !== null && _ref6 !== void 0 ? _ref6 : '',
      pickupFirst: props.pickupFirst,
      pickupLast: props.pickupLast,
      pickupPhone: props.pickupPhone,
      giftCardTrigger: props.giftCardTrigger,
      giftCardNumber: props.giftCardNumber,
      giftCardPin: props.giftCardPin,
      paymentMethod: props.paymentMethod,
      cardNumber: props.cardNumber,
      expDate: props.expDate,
      cvv: props.cvv,
      shippingStreetAddress: (_props$shippingStreet3 = props.shippingStreetAddress) !== null && _props$shippingStreet3 !== void 0 ? _props$shippingStreet3 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.address1,
      shippingStreetAddress2: (_props$shippingStreet4 = props.shippingStreetAddress2) !== null && _props$shippingStreet4 !== void 0 ? _props$shippingStreet4 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.address2,
      shippingCity: (_props$shippingCity2 = props.shippingCity) !== null && _props$shippingCity2 !== void 0 ? _props$shippingCity2 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.city,
      shippingState: (_props$shippingState2 = props.shippingState) !== null && _props$shippingState2 !== void 0 ? _props$shippingState2 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.state,
      shippingZip: (_props$shippingZip2 = props.shippingZip) !== null && _props$shippingZip2 !== void 0 ? _props$shippingZip2 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.zipCode,
      shippingOther: props.shippingOther,
      billingStreetAddress: (_props$billingStreetA2 = props.billingStreetAddress) !== null && _props$billingStreetA2 !== void 0 ? _props$billingStreetA2 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.address1,
      billingCity: (_props$billingCity2 = props.billingCity) !== null && _props$billingCity2 !== void 0 ? _props$billingCity2 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.city,
      billingState: (_props$billingState2 = props.billingState) !== null && _props$billingState2 !== void 0 ? _props$billingState2 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.state,
      billingZip: (_props$billingZip2 = props.billingZip) !== null && _props$billingZip2 !== void 0 ? _props$billingZip2 : defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.zipCode,
      billingOther: props.billingOther,
      curbsideMake: props.curbsideMake,
      curbsideModel: props.curbsideModel,
      curbsideColor: props.curbsideColor,
      saveDeliveryAddress: props.saveDeliveryAddress || false,
      isTokenExEnabled: props.fullCart.isTokenExEnabled,
      giftCardApplied: props.giftCardApplied
    };
  },
  validationSchema: AuthenticationState.Unauthenticated ? unAuthenticatedSchema : authenticatedSchema,
  handleSubmit: function handleSubmit(values, _ref7) {
    var props = _ref7.props,
        setSubmitting = _ref7.setSubmitting;

    //Post Cart and Validate Cart
    if (typeof props.validateHandler !== 'function') {
      return false;
    }

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return props.validateHandler(values);

            case 3:
              _context.next = 9;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              orderErrorTracker(_context.t0.message);
              console.error('Error placing order', _context.t0.message);

            case 9:
              _context.prev = 9;
              setTimeout(function () {
                setSubmitting(false);
              }, 3000);
              return _context.finish(9);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5, 9, 12]]);
    }))();

    if (props.closeModal) {
      props.closeModal();
    }
  },
  displayName: 'Cart' // helps with React DevTools

});